<template>
    <modal>
        <modal-card
            :activeValidate="true"
            @confirm="confirm"
            @cancel="cancel"
            :headerTitle="$t('equipement.intervention.title')"
        >
            <div class="content-container">
                <span>
                    {{
                        equipementInterventions.length === 1
                            ? $t('equipement.intervention.subtitle.single')
                            : $t('equipement.intervention.subtitle.multiple')
                    }}
                    <ReglePastille cle="demandeIntervention.interventionEnCours" />
                </span>
                <div class="items-container">
                    <equipement-intervention-item
                        v-for="intervention in equipementInterventions"
                        :equipementIntervention="intervention"
                        :key="intervention.id"
                    />
                </div>
                <span>
                    {{ $t('equipement.intervention.confirmation') }}
                </span>
            </div>
        </modal-card>
    </modal>
</template>

<script lang="ts">
import { EquipementInvervention } from '@/models/EquipementInvervention';
import { defineComponent, PropType } from 'vue';
import EquipementInterventionItem from './EquipementInterventionItem.vue';
import Modal from '@/components/ui-components/Modal.vue';
import ModalCard from '@/components/ui-components/ModalCard.vue';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    components: { Modal, ModalCard, EquipementInterventionItem, ReglePastille },
    props: {
        equipementInterventions: { type: Array as PropType<EquipementInvervention[]> },
    },
    methods: {
        cancel() {
            this.$emit('cancel');
        },
        confirm() {
            this.$emit('confirm');
        },
    },
});
</script>

<style scoped>
.content-container {
    font-size: var(--font-size-low-medium);
    font-weight: 500;
}
.items-container {
    margin: 8px 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
}
</style>
